import { FlashResource } from '@lib/iab/iab-vast-model';

interface IFlashResource {
    apiFramework: string;
    _value: string;
}

const createFlashResource = ($flashResource: IFlashResource): FlashResource => {
    const res = new FlashResource();
    res.apiFramework = $flashResource.apiFramework;
    res.uri = $flashResource._value;
    return res;
};

export default createFlashResource;
